import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,[_c(VSubheader,{staticStyle:{"background-color":"#DDE7F8","font-weight":"bold","font-size":"16px"}},[_c(VRow,[_c(VCol,[_vm._v(" "+_vm._s(_vm.factor?.name)+" ("+_vm._s(_vm.factor?.ratio)+"%) ")]),_c(VSpacer),_c(VCol,{attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.score.toFixed(2))+" / "+_vm._s(_vm.max_score.toFixed(2))+" ")])],1)],1),_vm._t("default"),_vm._l((_vm.factor?.questions),function(question){return _c('RiskAssessmentQuestion',{key:question.id,attrs:{"question":question},on:{"onScoreUpdate":_vm.onQuestionScoreUpdate}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }